<template>
  <div class="about">
    <van-sticky >
    <van-nav-bar title="携号转网" :border="false"  left-arrow  @click-left="goBack" >
    </van-nav-bar>
    </van-sticky>


    <van-collapse v-model="activeName" accordion>
      <van-collapse-item title="什么是携号转网？" name="1">
        <div class="wcc-content">携号转网，也称作号码携带、移机不改号，也就是说一家电信运营商的用户，无需改变自己的手机号码，就能转而成为另一家电信运营商的用户，并享受其提供的各种服务。
        </div><div class="wcc-content">2019年8月5日，携号转网进入落地阶段   。11月10日，三大运营商携号转网服务正式进入试运行阶段 。
      </div><div class="wcc-content">2019年11月27日，工信部召开携号转网启动仪式，即日起，携号转网正式在全国提供服务</div>
      </van-collapse-item>
      <van-collapse-item title="如何办理携号转网？" name="2">
        <div class="wcc-header-2">第一步 查询资格</div>
        <div class="wcc-content">拿起你的手机通过短信在线查询携转资格（短信编辑CXXZ#用户名#证件号码，发送至归属运营商，移动10086，联通10010，电信10001）：
        </div><div class="wcc-header-2">第二步 确认授权
      </div><div class="wcc-content">用户通过短信申请授权码（短信指令:SQXZ#用户名#证件号码，发送至归属运营商，移动10086，联通10010，电信10001）：
      </div><div class="wcc-header-2">第三步 营业厅办理
      </div><div class="wcc-content">收到授权码以后，带着你的有效证件和授权码去你想要使用的运营商营业办理新套餐即可！
      </div><div class="wcc-content">新规明确，从2019年12月1日开始，手机用户可以通过短信查询是否具有携号转网资格并申请授权码，然后前往转入方的运营商营业厅办理携号转网业务，但并不能在线或短信办理。
      </div><div class="wcc-header-2">提醒，如果要携号转网必须满足以下条件：
      </div><div class="wcc-content">1)	首先不能有拖欠费用的行为；
      </div><div class="wcc-content">2)	其次必须是用自己实名的电话卡；
      </div><div class="wcc-content">3)	还有参加相应运营商的套餐都要已经结束才能进行携号转网。</div>


      </van-collapse-item>
      <van-collapse-item title="主流资费信息说明" name="3">
        <div class="wcc-content">在转网建议页面中推荐的主流资费，信息来自三大运营商官方数据，但资费信息更新可能有延后，具体套餐和资费以实际业务办理为准。</div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
  export default {
    data:function(){
      return {
        activeName:"1"
      }
    },
    methods:{
      goBack:function(){
        if(window.JSInterface) {
          window.JSInterface.callMethod('close', null)
        }
        else if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface){
          window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
        }
      },
    }
  }
</script>

<style>
  .wcc-header-1{
    text-align: center;
    font-size: 1.2em;
    line-height: 2em;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .wcc-header-2{
    font-size: 1.1em;
    line-height: 2em;
    font-weight: bold;
  }
  .wcc-content{
    text-indent: 2em;
    margin-bottom: 10px;
  }

   .van-collapse-item__content{
     background-color: inherit!important;
   }

</style>
